<div>
  <form [formGroup]='gatewayForm' class='or-form or-form-gateway-details' name='gatewayForm' novalidate='novalidate'>
    @if (gateways(); as gatewayList) {
      <div class='or-form-body'>
        @for (gateway of gatewayList; track gateway.id; let i = $index) {
          <ol class='or-form-items'>
            <li class='or-form-item or-form-item-status or-form-gateway-details-keys or-gateways'>
              <app-gateway-health-status
                [gatewayHealth]='gateway.gatewayHealth'
                [primary]='true'
                dataTest='form-gateway-details-health'>
              </app-gateway-health-status>
            </li>
            <li class='or-form-item or-form-gateway-details-name or-gateways'>
              <input class='or-input' type='text' maxlength='256' value='{{gateway.serialNumber}}'
                name='serialNumber{{i}}'
                placeholder='Serial Number'
                disabled
                data-test='otap-gateway-details-serial-number' />
            </li>
            <li class='or-form-item or-form-gateway-details-name or-gateways'>
              <input class='or-input' type='text' maxlength='256' value='{{gateway.address}}'
                name='address{{i}}'
                placeholder='Address'
                disabled
                data-test='otap-gateway-details-address' />
            </li>
            <li class='or-form-item or-gateways'>
              <button class='or-button or-iconic or-primary or-negative' type='button' (click)='onDelete(gateway)'
                data-cy='delete-gateway-{{gateway.id}}}'
                title='Delete gateway' data-test='form-gateway-details-delete'>
                <span class='or-icon or-tiny or-inverse or-icon-trash'></span>
              </button>
            </li>
            <li class='or-form-item or-gateways'>
              <button class='or-button or-iconic ' type='button' (click)='onRebootGateway(gateway)'
                data-cy='reboot-gateway-{{gateway.id}}}'
                title='Reboot gateway' data-test='form-gateway-details'>
                <span class='or-icon or-small or-icon-reload'></span>
              </button>
            </li>
            <ol class='or-gateway-metrics-items'>
              <li>
                @if (gateway.gatewayMetric !== undefined && gateway.gatewayMetric.cpuUsage !== undefined) {
                  <label class=' or-label or-gateway-metrics-item'
                    >
                    CPU: {{Math.round(gateway.gatewayMetric.cpuUsage)}}%
                  </label>
                }
                @if (gateway.gatewayMetric !== undefined && gateway.gatewayMetric.diskUsage !== undefined) {
                  <label class=' or-label or-gateway-metrics-item'
                    >
                    Disk: {{Math.round(gateway.gatewayMetric.diskUsage)}}%
                  </label>
                }
                @if ( gateway.gatewayMetric !== undefined && gateway.gatewayMetric.memoryUsage!== undefined) {
                  <label class=' or-label or-gateway-metrics-item'
                    >
                    Memory: {{Math.round(gateway.gatewayMetric.memoryUsage)}}%
                  </label>
                }
                @if ( gateway.sensorNodeCount !== undefined ) {
                  <label class=' or-label or-gateway-metrics-item'
                    >
                    Sensor nodes : {{gateway.sensorNodeCount}}
                  </label>
                }
              </li>
            </ol>
          </ol>
        }
        <ol class='or-form-items otap-gateway-details-input'>
          <div class='or-form-header'>
            <h2 class='or-form-title'>New Gateway</h2>
          </div>
          <li class='or-form-item or-form-gateway-details-name'>
            <input class='or-input' type='text' maxlength='256'
              formControlName='newSerialNumber'
              placeholder='Serial Number'
              required
              name='newSerialNumber'
              data-test='otap-form-gateway-details-serial-number' />
          </li>
          <li class='or-form-item'>
            <button class='or-button or-iconic or-primary or-positive' type='button'
              data-cy='add-gateway-to-job-{{job().id}}}'
              (click)='onAddGateway()' title='Add gateway' [disabled]='!gatewayForm.valid'
              data-test='form-gateway-details-add'>
              <span class='or-icon or-small or-inverse or-icon-plus'></span>
            </button>
          </li>
        </ol>
        <div class='otap-gateway-details-buttons'>
          <button
            mat-raised-button
            color='primary'
            type='submit'
            class=' otap-gateway-details-button'
            data-cy='reboot-all-gateways'
            (click)='onRebootAllGateways()'
            [disabled]='gatewayList.length === 0'
            >
            <span class='or-icon or-small or-inverse or-icon-reload'></span>
            <span class='or-button-label'>Reboot All Gateways</span>
          </button>
        </div>

        <li class="or-form-item">
          <button
            mat-raised-button
            color='primary'
            class="or-button or-iconic"
            type="button"
            title="Import gateways from building"
            (click)="onOpenImportDialog()"
            data-test="otap-import-gateways-from-building"
          >
            <span class="or-icon or-small or-icon-upload"></span>
            <span class="or-button-label">Import Gateways from building</span>
          </button>
        </li>
          <div class='otap-gateway-details-buttons'>
            <button
              mat-raised-button
              color='primary'
              type='submit'
              class=' otap-gateway-details-button'
              data-cy='reboot-all-gateways'
              (click)='onRebootAllGateways()'
              [disabled]='gatewayList.length === 0'
            >
              <span class='or-icon or-small or-inverse or-icon-reload'></span>
              <span class='or-button-label'>Reboot All Gateways</span>
            </button>
            <button
              mat-raised-button
              color='primary'
              type='submit'
              class='submit-btn otap-gateway-details-button'
              data-cy='export-otap-process'
              (click)='onExportOtapProcess()'
              [disabled]='gatewayList.length === 0 || exportInProgress()'>
                @if (!exportInProgress()) {
                    <span class='or-icon or-small or-inverse or-icon-report'></span>
                }
              <span class='or-button-label'>
              {{ exportInProgress() ? 'Loading...' : 'Export' }}
              </span>
            </button>
              @if (job().status === "STARTED") {
                  <button mat-raised-button
                          color='warn'
                          type='submit'
                          class='submit-btn otap-gateway-details-button'
                          data-cy='export-otap-process'
                          (click)='onStopJob()'
                  >
                      <span class='or-icon or-small or-inverse or-icon-deactivate'></span>
                      <span class='or-button-label'>Stop</span>
                  </button>
              }
              @if (job().status === "ENDED") {
                  <button mat-raised-button
                          color='accent'
                          type='submit'
                          class='submit-btn otap-gateway-details-button'
                          data-cy='export-otap-process'
                          (click)='onReopenJob()'
                  >
                      <span class='or-icon or-small or-inverse or-icon-deactivate'></span>
                      <span class='or-button-label'>Reopen</span>
                  </button>
              }
              @if (job().status === "STARTED") {
                  <button mat-raised-button
                          color='accent'
                          type='submit'
                          class='submit-btn otap-gateway-details-button button-alignment-right'
                          data-cy='manually-enable-start-otap-process'
                          (click)='onManuallyEnableStartButtons()'
                          [disabled]='gatewayList.length === 0'
                  >
                      <span class='or-icon or-small or-inverse'></span>
                      <span class='or-button-label'>Manually enable start buttons</span>
                  </button>

              }
          </div>
      </div>
    }
  </form>
</div>
